import React from 'react'
import RevealNft from '../../components/minting-page/RevealNft'

const RevealMintNft = () => {
  return (
    <RevealNft />
  )
}

export default RevealMintNft